module.exports = __webpack_public_path__ + "pdf/coworkers.1e0fcc6.pdf";